import type { FluxErrorEntityErrorCodes } from '../types.js';

export const StageErrorCodes = {
  StageArchived: {
    code: 'stage/archived',
    message: 'Esta etapa está arquivada e não pode ser modificada.',
    explanation: 'A etapa que você está tentando modificar está arquivada. Etapas arquivadas são imutáveis.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Configurações da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
  StageDeleteFailed: {
    code: 'stage/delete-failed',
    message: 'Erro ao excluir a etapa. Tente novamente.',
    explanation: 'Ocorreu um erro ao tentar excluir a etapa.',
    localizations: {},
  },
  StageDoesNotHaveDeadline: {
    code: 'stage/does-not-have-deadline',
    message: 'Esta etapa não possui um prazo definido.',
    explanation: 'A etapa não possui um prazo definido. Prazos são configurados por etapa no fluxo.',
    localizations: {},
    supportingDocs: [
      {
        name: 'Configurações da Etapa',
        path: '/wiki/docs/pipe/stages/configuration',
      },
    ],
  },
  StageNotFound: {
    code: 'stage/not-found',
    message: 'A etapa solicitada não foi encontrada.',
    explanation: 'A etapa que você está tentando acessar não foi encontrada. Ela pode ter sido removida ou não existir neste fluxo.',
    localizations: {},
  },
  StageStageCannotBeMovedLeft: {
    code: 'stage/stage-cannot-be-moved-left',
    message: 'Esta etapa não pode ser movida para a esquerda.',
    explanation: 'A etapa não pode ser movida para a esquerda. Essa etapa já está na posição mais à esquerda.',
    localizations: {},
  },
  StageStageCannotBeMovedRight: {
    code: 'stage/stage-cannot-be-moved-right',
    message: 'Esta etapa não pode ser movida para a direita.',
    explanation: 'A etapa não pode ser movida para a direita. Essa etapa já está na posição mais à direita.',
    localizations: {},
  },
  StageUndeleteFailed: {
    code: 'stage/undelete-failed',
    message: 'Erro ao restaurar a etapa.',
    explanation: 'Ocorreu um erro desconhecido ao tentar restaurar a etapa. Verifique suas informações e tente novamente.',
    localizations: {},
  },
  StageUpdateFailed: {
    code: 'stage/update-failed',
    message: 'Erro ao atualizar a etapa. Verifique suas informações e tente novamente.',
    explanation: 'Ocorreu um erro desconhecido ao tentar atualizar a etapa. Verifique suas informações e tente novamente.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'stage'>;
